module.exports = "images/apple-icon-57x57.affdaf1b568b976d3860a7aa55b0cfe8.png";